document.addEventListener('DOMContentLoaded', () => {
  const curatorsTitle = document.querySelector('.main-page-curators__h1');

  if (!curatorsTitle) return;

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (typeof window.sendAdRiverEvent === 'function') {
        window.sendAdRiverEvent('5');
      }

      observer.disconnect();
    }
  });

  observer.observe(curatorsTitle);
});
